import { ProjectComponentStyled } from "../Style-components/ProjectCompnent.Styled";
import ProjectTools from "./ProjectTools";

function ProjectComponent({ item }) {
  return (
    <ProjectComponentStyled>
      <h4>{item.type}</h4>
      <div>
        <p className="desc head">
          <a href={item.link} target="_blank" rel="noopener noreferrer">
            {item.name}
          </a>
        </p>
        <p className="desc">
          <span style={{ fontSize: "10px" }}>&#9899; &nbsp;</span>
          {item.description}
        </p>
        <p>
          <ProjectTools tool={item.tools} />
        </p>
      </div>
    </ProjectComponentStyled>
  );
}

export default ProjectComponent;
